
import React from "react";
import { Control } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Clock } from "lucide-react";
import { WaitlistFormValues, timelineOptions } from "../schema";

interface SectionProps {
  control: Control<WaitlistFormValues>;
}

export function TimelineSection({ control }: SectionProps) {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-grandpal-beige">
      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        <Clock className="h-5 w-5 text-grandpal-green" />
        Timeline & Urgency
      </h3>
      
      <FormField
        control={control}
        name="timeframe"
        render={({ field }) => (
          <FormItem className="space-y-3">
            <FormLabel>When do you need nursing home care?</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                defaultValue={field.value}
                className="flex flex-col space-y-1"
              >
                {timelineOptions.map(option => (
                  <FormItem key={option.id} className="flex items-center space-x-3 space-y-0">
                    <FormControl>
                      <RadioGroupItem value={option.id} />
                    </FormControl>
                    <FormLabel className="font-normal">
                      {option.label}
                    </FormLabel>
                  </FormItem>
                ))}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
